import classnames from 'classnames';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import Slider, { Settings } from 'react-slick';

import { setHeaderColor } from '../../../Layout/store/actions';
import { IHomeProject } from '../../store/models';
import { SliderItem } from './SliderItem';

import './index.scss';

interface IProps {
    projects: IHomeProject[];
}

interface ISliderArrow {
    onClick?: () => void;
    arrowForward?: 'prev' | 'next';
}

const SliderArrow: React.FC<ISliderArrow> = ({ arrowForward, onClick }) => (
    <div
        onClick={onClick}
        className={classnames(`slider-nav slick-arrow slider-nav-${arrowForward}`)}
    >
        <div className="slider-nav-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="218.061" height="197.121" viewBox="0 0 218.061 197.121">
                <g id="Group_163" data-name="Group 163" transform="translate(1326.061 531.061) rotate(180)">
                    <g id="Group_67" data-name="Group 67" transform="translate(-1928.5 3160.5)">
                        <line id="Line_9" className="color-change" data-name="Line 9" x2="89" y2="89" transform="translate(3164.5 -2825.5)" fill="none" stroke="#272727" stroke-width="3" />
                        <line id="Line_10" className="color-change" data-name="Line 10" x1="89" y2="89" transform="translate(3164.5 -2719.5)" fill="none" stroke="#272727" stroke-width="3" />
                    </g>
                    <line id="Line_11" className="color-change" data-name="Line 11" x2="203" transform="translate(1108 432.5)" fill="none" stroke="#272727" stroke-width="3" />
                </g>
            </svg>
        </div>
    </div>
);

const SliderArrowPrev: React.FC<ISliderArrow> = ({ onClick }) => <SliderArrow arrowForward="prev" onClick={onClick} />;
const SliderArrowNext: React.FC<ISliderArrow> = ({ onClick }) => <SliderArrow arrowForward="next" onClick={onClick} />;

const carouselConfig: Settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
};

export const MainCarousel: React.FC<IProps> = ({ projects }) => {
    const dispatch = useDispatch();
    const [color, setColor] = React.useState();

    const handleColorChange = React.useCallback(
        (currentIndex: number = 0) => {
            const activeProject = projects[currentIndex];
            dispatch(setHeaderColor(activeProject.slider_text_color));
            setColor(activeProject.slider_text_color);
        },
        [dispatch, projects],
    );

    return (
        <div className="main-page_carousel">
            <Slider
                {...carouselConfig}
                afterChange={handleColorChange}
                onInit={handleColorChange}
                nextArrow={<SliderArrowNext />}
                prevArrow={<SliderArrowPrev />}
                className={`slider-${color}`}
            >
                {
                    projects.map((project, index) => (
                        <SliderItem
                            project={project}
                            key={project.id}
                            index={index}
                            totalItems={projects.length}
                        />
                    ))
                }
            </Slider>
        </div>
    );
};
